import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DatetimeField } from 'components/DatetimeField';
import { Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { useStyles, customCardStyles } from './TaxRulesetHistory.styled';
import i18n from 'i18n-js';
import { Card } from 'components/UI';
import { Table } from 'components/UI';
import { SkusActions } from 'state/modules/skus';
import { buildUrl } from 'utils';
import { FETCH_STATE } from 'constants/common';

export const AssociatedTaxRuleset = (props) => {
  const { skuId } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const cardClasses = customCardStyles();
  const list = useSelector((state) => state?.skus?.associatedTaxRuleset);
  const pagination = useSelector((state) => state?.skus.associatedTaxRulesetPagination);
  const fetchingAssociatedTaxRuleset = useSelector(
    (state) => state?.skus.fetchingAssociatedTaxRuleset
  );
  const fetchedUpdateSku = useSelector((state) => state?.skus?.fetchedUpdateSku);
  const title = i18n.t('tax_ruleset.associated_tax_rulesets');
  const [params, setParams] = useState({
    archived: true,
    limit: 5,
    page: 1,
  });

  const loading = fetchingAssociatedTaxRuleset === FETCH_STATE.LOADING;

  /**
   * Table columns
   * Show or hide columns with omit key
   */
  const columns = [
    {
      name: i18n.t('common.id'),
      selector: 'id',
      grow: 0,
      minWidth: '4rem',
    },
    {
      name: i18n.t('tax_ruleset.rulesets'),
      selector: 'name',
      cell: (row) => row?.name,
      minWidth: '10rem',
    },
    {
      name: i18n.t('common.start_date'),
      selector: 'start_time',
      cell: (row) => <DatetimeField datetime={row?.start_time} />,
      grow: 1,
      minWidth: '10rem',
    },
    {
      name: i18n.t('common.end_date'),
      selector: 'end_time',
      cell: (row) => <DatetimeField datetime={row?.end_time} />,
      grow: 1,
      minWidth: '10rem',
    },
  ];

  const fetchAssociatedTaxRulesets = useCallback(
    (id, params) => {
      dispatch(SkusActions.fetchAssociatedTaxRuleset(id, params));
    },
    [dispatch]
  );

  const handlePageChange = (page) => {
    const newParams = { page, limit: params.limit };
    setParams({ ...params, ...newParams });
  };

  const handleRowClick = (taxRuleset) => {
    history.push(buildUrl(`/tax-rulesets/${taxRuleset.id}`));
  };

  // Fetch tax rulesets by sku id
  useEffect(() => {
    if (skuId) {
      fetchAssociatedTaxRulesets(skuId, params);
    }
  }, [fetchAssociatedTaxRulesets, skuId, params]);

  useEffect(() => {
    if (skuId && fetchedUpdateSku) {
      fetchAssociatedTaxRulesets(skuId, params);
    }
  }, [fetchAssociatedTaxRulesets, skuId, fetchedUpdateSku]);

  return (
    <Card
      menuItems={[]}
      headerActionType="vertical"
      contentRootClasses={cardClasses}
      data-cy="taxruleset-history-widget"
      title={title}
    >
      <Box className={classes.cardContentPadding}>
        <Table
          data={list}
          columns={columns}
          loading={loading}
          handlePageChange={handlePageChange}
          paginationPerPage={params?.limit || 0}
          totalRows={pagination?.totalRows || 0}
          paginationComponentOptions={{ noRowsPerPage: true }}
          handleRowClicked={handleRowClick}
        />
      </Box>
    </Card>
  );
};
